import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {TimeZoneSearchModel} from "../time-zone-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-time-zone-single-select-edit-control",
    templateUrl: "../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(TimeZoneSingleSelectEditControlComponent),
        provideSearchModel(TimeZoneSearchModel)
    ]
})
export class TimeZoneSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<TimeZoneSearchModel> {
    constructor(model: TimeZoneSearchModel, injector: Injector) {
        super(model, injector, "timeZone", "timeZone");
    }
}
